
export class FileManagerFolderDetailsInput
{
	currentDirectoryId: string;

	constructor(currentDirectoryId: string)
	{
		this.currentDirectoryId = currentDirectoryId;
	}
}

export class FileManagerRenameInput
{
	id: string;
	type: string;
	name: string;

	constructor(id: string, type: string, name: string)
	{
		this.id = id;
		this.type = type;
		this.name = name;
	}
}